import { endpoints } from 'src/utils/axios';

import { createObjectHook, createPartialUpdateAction } from '../utils/create-action';

const endpoint = {
  details: endpoints.knowledge.llmConfig,
};

export type BedrockModelOption = {
  value: string;
  label: string;
  description?: string;
};

export type LlmConfig = {
  provider: string;
  bedrockModelArn: string;
  availableBedrockModels: BedrockModelOption[];
};

export const useGetLlmConfig = createObjectHook(endpoint.details);

export const updateLlmConfig = createPartialUpdateAction(endpoint.details, {
  payloadTransformer: (data: { bedrockModelArn: string }) => ({
    bedrockModelArn: data.bedrockModelArn,
  }),
  idField: null,
});